export default __webpack_public_path__ + "static/concept_1-b742bc048bed2ccd4ddd6bc4e13933f0.jpg";